/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/internal/realNames.js
 ** module id = 395
 ** module chunks = 0 1
 **/